import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import { BrowserRouter } from 'react-router-dom'

import Alert from './components/containers/Alert'
import Router from './components/Router'
import './styles/App.css'
import './styles/Common.css'
import './styles/icons.css'

import * as Constants from './helpers/Constants'

const muiTheme = getMuiTheme({
  fontFamily: 'Lato',
  palette: {
    primary2Color: '#297CCA'
  },
  datePicker: {
    color: Constants.WHITE_LABEL.colors.calendar.today,
    selectColor: Constants.WHITE_LABEL.colors.calendar.daybutton
  }
})

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <Alert />
      </MuiThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js